<template>
  <app-loading :active="$wait.is('app loading')"></app-loading>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import store from '@/store'
import { mapWaitingActions } from 'vue-wait'

export default {
  name: 'KPaymentCallbackPage',
  components: {
    AppLoading: () => import('@/components/AppLoading.vue')
  },
  data() {
    return {
      fetchCurrent: 1,
      fetchMaximum: 3,
      fetchEvery: 3000
    }
  },
  computed: {
    ...mapState('User', ['userProfile'])
  },
  async mounted() {
    store.dispatch('wait/start', 'app loading', { root: true })

    const order = this.$utils.getKPaymentCheckout()

    if (order) {
      await this.fetchOrder()
    } else {
      this.$swal({
        title: 'มีบางอย่างผิดพลาด',
        text: 'กรุณาทดลองใหม่ หรือติดต่อเจ้าหน้าที่',
        icon: 'error'
      }).finally(() => {
        this.$wait.end('app loading')
        this.$router.push({ name: 'Home' })
      })
    }
  },
  destroyed() {
    this.$utils.removeKPaymentCheckout()
    this.$utils.removeKPaymentChargeId()
    this.$utils.removeKPaymentUserSaveCard()
  },
  methods: {
    ...mapActions({
      fetchProfile: 'User/fetchProfile',
      inquiryTransaction: 'Payment/inquiryTransaction',
      createCustomer: 'Payment/createCustomer',
      fetchOrderById: 'Order/fetchOrderById',
      insertNewCard: 'Payment/insertNewCard'
    }),
    ...mapWaitingActions('User', {
      fetchProfile: 'app loading'
    }),
    async fetchOrder() {
      try {
        const order = JSON.parse(this.$utils.getKPaymentCheckout()) || {}

        if (this.fetchMaximum > this.fetchCurrent) {
          setTimeout(async () => {
            await this.fetchOrderById(order._id).then(async (response) => {
              if (response.status === 'paid') {
                const payloadUserSaveCard = this.$utils.getKPaymentUserSaveCard()

                if (payloadUserSaveCard) {
                  if (this.userProfile?.kpayment) {
                    const customerId = this.userProfile?.kpayment.customerId
                    const payload = JSON.parse(payloadUserSaveCard)

                    await this.insertNewCard({
                      id: customerId,
                      params: {
                        mode: 'token',
                        token: payload.token
                      }
                    })
                  } else {
                    await this.createCustomer(JSON.parse(payloadUserSaveCard))
                  }
                }

                await this.fetchProfile()

                this.$utils.removeKPaymentCheckout()
                this.$utils.removeKPaymentChargeId()
                this.$utils.removeKPaymentUserSaveCard()
                this.$wait.end('app loading')
                this.$router.push({ name: 'UploadSlipSuccess',
                  params: { order }
                })
              } else {
                this.fetchOrder()
              }
            }).finally(() => {
              this.fetchCurrent += 1
            })
          }, this.fetchEvery)
        } else {
          const chargeId = this.$utils.getKPaymentChargeId()

          await this.inquiryTransaction(chargeId)
            .then(async (response) => {
              if (response.status === 'success') {
                await this.fetchProfile()

                this.$utils.removeKPaymentCheckout()
                this.$utils.removeKPaymentChargeId()
                this.$utils.removeKPaymentUserSaveCard()
                this.$wait.end('app loading')
                this.$router.push({ name: 'UploadSlipSuccess',
                  params: { order }
                })
              } else {
                this.$swal({
                  text: this.$utils.vaildateErrorCode(response.failure_code),
                  icon: 'error'
                }).finally(() => {
                  this.$wait.end('app loading')
                  this.$router.push({ name: 'Home' })
                })
              }
            }).catch(() => {
              this.$swal({
                title: 'มีบางอย่างผิดพลาด',
                text: 'กรุณาทดลองใหม่ หรือติดต่อเจ้าหน้าที่',
                icon: 'error'
              }).finally(() => {
                this.$wait.end('app loading')
                this.$router.push({ name: 'Home' })
              })
            })
        }
      } catch (error) {
        this.$swal({
          title: 'มีบางอย่างผิดพลาด',
          text: 'กรุณาทดลองใหม่ หรือติดต่อเจ้าหน้าที่',
          icon: 'error'
        }).finally(() => {
          this.$wait.end('app loading')
          this.$router.push({ name: 'Home' })
        })
      }
    }
  }
}
</script>
